<div class="crusher-data-section">
  <h4 class="crusher-data-title">Crusher Data Import</h4>
  <p class="crusher-data-hint">Import the latest CSV. New columns are detected automatically.</p>

  <input
    type="file"
    id="csv-file-input"
    accept=".csv"
    (change)="onFileSelected($event)"
    hidden
  />

  <app-button
    variant="primary"
    color="amarante"
    size="small"
    [label]="isPreviewing() ? 'Analyzing…' : isUploading() ? 'Uploading…' : 'Upload CSV'"
    [addIconLeft]="true"
    [state]="isUploading() || isPreviewing() ? 'disabled' : 'default'"
    (clicked)="triggerFileInput()"
    data-attr="crusher-data-btn-upload">
    <img slot="icon-left" class="crusher-data-upload-icon" src="assets/icon/new_icon/Importer.svg" alt="" />
  </app-button>

  @if (isUploading()) {
    <div class="crusher-progress">
      <div
        class="crusher-progress__bar"
        role="progressbar"
        [style.width.%]="progress()"
        [attr.aria-valuenow]="progress()"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        {{ progress() }}%
      </div>
    </div>
  }

  @if (result(); as r) {
    <div class="import-result">
      <div class="crusher-alert crusher-alert--success">
        <i class="fas fa-check-circle"></i>
        <span>Import completed successfully</span>
      </div>
      <div class="import-stats">
        <div class="stat-row">
          <span class="stat-label">Rows analysed</span>
          <span class="stat-value">{{ r.totalRows }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">New rows inserted</span>
          <span class="stat-value stat-value--success">{{ r.inserted }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Rows updated</span>
          <span class="stat-value stat-value--info">{{ r.updated }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Rows already existed</span>
          <span class="stat-value stat-value--muted">{{ r.alreadyExisting }}</span>
        </div>
        @if (r.columnsAdded.length > 0) {
          <div class="stat-row">
            <span class="stat-label">New columns added</span>
            <span class="stat-value stat-value--warning">{{ r.columnsAdded.length }}</span>
          </div>
        }
      </div>
      @if (r.columnsAdded.length > 0) {
        <div class="crusher-alert crusher-alert--info">
          <strong>New columns created:</strong>
          <code>{{ r.columnsAdded.join(', ') }}</code>
        </div>
      }
      @if (r.errors && r.errors.length > 0) {
        <div class="crusher-alert crusher-alert--warning">
          <strong>Warnings:</strong>
          <ul>
            @for (err of r.errors; track err) {
              <li>{{ err }}</li>
            }
          </ul>
        </div>
      }
    </div>
  }

  @if (error(); as err) {
    <div class="crusher-alert crusher-alert--danger">
      <i class="fas fa-times-circle"></i>
      <span>{{ err }}</span>
    </div>
  }
</div>
